function PouzitiePlynov(){
    return(<div>
        Pouzitie plynov
    </div>
    );
};

export default PouzitiePlynov;